import * as React from "react"

const CustomerExp = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 269.1 287.4" {...props}>
    <title>{"Customer-Service-Shipx-2"}</title>
    <path
      d="M134.77 0 141 19.12h20.11l-16.29 11.82L151 50.06l-16.23-11.82-16.22 11.82 6.22-19.12-16.32-11.82h20.1ZM61.55 16.24 75.3 30.91l18.2-8.54L83.8 40l13.75 14.7-19.75-3.79-9.7 17.62-2.5-20-19.79-3.83L64 36.15ZM2.1 62.09l18.68 7.43 12.85-15.47-1.3 20.06L51 81.55l-19.48 5-1.3 20.07-10.74-17-19.48 5 12.85-15.54ZM205.09 36.19l18.2 8.55-19.74 3.78-2.5 20-9.7-17.62-19.8 3.8L185.3 40l-9.7-17.61L193.8 31l13.75-14.72ZM256.25 79.08l12.85 15.47-19.49-5-10.74 17-1.32-20-19.48-5 18.68-7.44-1.3-20.11 12.85 15.48 18.7-7.43Z"
      fill="#b1da00"
      fillRule="evenodd"
    />
    <path
      d="M135 247.3a73.61 73.61 0 0 1-40.8-12.22l-31.1 8.84 8.9-31.46a74.29 74.29 0 1 1 63 34.84Z"
      fill="#007f6e"
    />
    <path
      d="m96.31 222.39 2.28 1.61A62.1 62.1 0 0 0 135 235.7a62.76 62.76 0 1 0-51.83-27.47l1.53 2.25-4.7 16.59Z"
      fill="#b1da00"
    />
    <path
      d="M242.06 140.94h-4.86c-12.81-45.21-54.8-77.82-102.87-77.82s-90 32.61-102.86 77.82h-5.16a10.72 10.72 0 0 0-10.71 10.73v43.22a10.73 10.73 0 0 0 10.71 10.71h14.37a10.71 10.71 0 0 0 10.7-10.71V151.7a10.7 10.7 0 0 0-6.89-10c12.18-38.43 48.45-65.87 89.84-65.87a94.73 94.73 0 0 1 89.81 65.77 10.72 10.72 0 0 0-7.14 10.1v43.19a10.69 10.69 0 0 0 6.31 9.75c-11.53 33.06-37.64 55.06-72.15 61a14.67 14.67 0 0 0-12.85-7.59h-7.93a14.68 14.68 0 0 0 0 29.35h7.93a14.69 14.69 0 0 0 13.54-9c40-6.38 70.37-31.69 83.56-70l.87-2.52-.88-.3h6.67a10.73 10.73 0 0 0 10.71-10.71V151.7a10.72 10.72 0 0 0-10.68-10.76Z"
      fill="#007f6e"
    />
    <path
      d="m143 158.12-10.42 36.2a20.31 20.31 0 0 0-.87 4.08 1.46 1.46 0 0 0 .46 1 1.33 1.33 0 0 0 1 .48 2.62 2.62 0 0 0 1.73-.76 31.78 31.78 0 0 0 5.5-6.83l1.73 1q-7.72 13.41-16.39 13.41a7.39 7.39 0 0 1-5.27-1.85 6.23 6.23 0 0 1-2-4.71 17.37 17.37 0 0 1 .87-4.79l7.05-24.35a21.3 21.3 0 0 0 1-5.3 2.58 2.58 0 0 0-1-2 3.86 3.86 0 0 0-2.65-.87h-1.84l.67-2 17.26-2.8Zm-3.15-23.42a7.19 7.19 0 0 1 5.32 2.19 7.31 7.31 0 0 1 2.16 5.3 7.46 7.46 0 1 1-12.75-5.3 7.14 7.14 0 0 1 5.24-2.19Z"
      fill="#fff"
    />
  </svg>
)

export default CustomerExp
